import { useFilterData } from "../../hooks/useFilterData";
import { useTargetsRequest, useDownloadPosYearTargetExcelRequest, useFeaturesEnabledRequest, useUpdatePosPeriodRequest } from "../../hooks/useApi";
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState, useCallback } from "react";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import FormControl from '@mui/material/FormControl';
import TargetTable from './TargetTable';
import OutlinedBtn from '../../components/OutlinedBtn';
import { CopyBudget } from '../../components/CopyBudget/index';
import * as React from 'react';
import NoResultsIcon from '../../components/Icons/NoResultsIcon';
import StorefrontIcon from '../../components/Icons/StorefrontIcon';
import SwapIcon from '../../components/Icons/SwapIcon';
import DownloadIcon from '../../components/Icons/DownloadIcon';
import UploadIcon from '../../components/Icons/UploadIcon';
import RefreshIcon from '../../components/Icons/RefreshIcon';
import Pagination from '@mui/material/Pagination';
import { Stack } from "@mui/material";
import { downloadFile, choosedMonths, prepareParamsForPosUpdate } from '../../utils/helpers';
import LoadingOverlay from '../../components/LoadingOverlay';
import { MonthRangePicker } from "../../components/MonthRangePicker";
import OutlinedBlackBtn from '../../components/OutlinedBlackBtn';
import SelectStoreModal from '../../components/SelectStoreModal';
import UploadKpiModal from '../../components/UploadKpiModal';
import UploadBudgetModal from '../../components/UploadBudgetModal';

const Dashboard = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedPeriodRange = JSON.parse(localStorage.getItem('selectedPeriodRange')) || {selectedYear: null, startMonth: null, endMonth: null};
  const countriesStr = searchParams.get("countries") || '';
  const pageSizeStr = searchParams.get("pageSize") || 10;
  const pageIndexStr = searchParams.get("pageIndex") || 1;
  const { countries, executeSearchCountry, years } = useFilterData();
  const [ { loadingFE }, getFeaturesEnabled ] = useFeaturesEnabledRequest();
  const [ { loading }, executeRequest ] = useTargetsRequest();
  const [ { loading: loadingFile}, downloadExcel ] = useDownloadPosYearTargetExcelRequest();
  const [selectedCountries, setCountry] = useState(countriesStr ? countriesStr.split(',') : []);
  const [selectedYear, setYear] = useState(selectedPeriodRange?.selectedYear);
  const [startMonth, setGlobalStartMonth] = useState(selectedPeriodRange?.startMonth);
  const [endMonth, setGlobalEndMonth] = useState(selectedPeriodRange?.endMonth);
  const [targetData, setTargetData] = useState(null);
  const [pageSize, setPageSize] = useState(pageSizeStr);
  const [pageIndex, setPageIndex] = useState(pageIndexStr);
  const [selectedPosIds, setPosId] = useState({});
  const [showCopyPrevYear, setShowCopyPrevYear] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openKpiModal, setOpenKpiModal] = useState(false);
  const [openBudgetModal, setOpenBudgetModal] = useState(false);
  const [featuresEnabled, setFeaturesEnabled] = useState({uploadExcelKPI: false, uploadExcelBudget: false});
  const modalParams = JSON.parse(localStorage.getItem('modalParams'));
  const [visiblePosIds, setVisiblePosIds] = useState(modalParams?.visiblePosIds || []);
  const [downloadError, setDownloadError] = useState(null);
  const [ {}, updatePosPeriod ] = useUpdatePosPeriodRequest();

  const FetchTargetSales = useCallback((setAllData) => {
    const aaa = async () => {
      if (visiblePosIds.length > 0 && startMonth >= 0)
      {
        const bodyParams = {
          year: selectedYear,
          months: choosedMonths(startMonth, endMonth),
          posIds: visiblePosIds,
          pageSize: pageSize,
          pageIndex: pageIndex
        };

        const response = await executeRequest({ bodyParams });
        setTargetData(response?.data);
      }
    };

    aaa();
  }, [visiblePosIds, setVisiblePosIds, selectedYear, startMonth, setGlobalStartMonth, endMonth, setGlobalEndMonth, pageIndex, pageSize]);

  useEffect(() => {
    FetchTargetSales();
  }, [pageSize, pageIndex, visiblePosIds, setVisiblePosIds, selectedYear, startMonth, setGlobalStartMonth, endMonth, setGlobalEndMonth]);

  useEffect( async () => {
    const response = await getFeaturesEnabled();
    setFeaturesEnabled(JSON.parse(response?.data));
  }, []);

  // 
  useEffect(() => {
    setPageIndex(1);
    setSearchParams({ pageSize: pageSize, pageIndex: 1 });
  }, [visiblePosIds, setVisiblePosIds, selectedYear, setYear, startMonth, setGlobalStartMonth, endMonth, setGlobalEndMonth]);
  if (!years || loading || loadingFile)
    return <LoadingOverlay />

  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const handleOpenKpiModal = () => {
    setOpenKpiModal(true);
  };
  const handleCloseKpiModal = () => {
    setOpenKpiModal(false);
  };
  const handleOpenBudgetModal = () => {
    setOpenBudgetModal(true);
  };
  const handleCloseBudgetModal = () => {
    setOpenBudgetModal(false);
  };
  const handleChangePageSzie = (event) => {
    const { target: { value } } = event;
    setSearchParams({ pageSize: value, pageIndex: 1 });
    setPageSize(value);
    setPageIndex(1);
  };

  const handleChangePageIndex = (event, value) => {
    setSearchParams({ pageSize: pageSize, pageIndex: value });
    setPageIndex(value);
  };

  const downloadExcelHandleClick = async (event) => {
    const bodyParams = {
      pageIndex,
      pageSize,
      posIds: visiblePosIds,
      year: selectedYear,
      months: choosedMonths(startMonth, endMonth),
    };
    const fileName = `StoreBudget-${selectedYear}.xlsx`;
    const error = await downloadFile(bodyParams, fileName, downloadExcel);
    if (error)
      setDownloadError(error);
    // await FetchTargetSales();
  }

  const handelChangePosId = async (event) => {
    const { target: { value, checked } } = event;
    const obj = Object.assign({}, selectedPosIds);
    if (checked == false)
    {
      delete obj[value];
      setPosId(obj);
    }
    else
      setPosId((prevCheckStates) => {
        return { ...prevCheckStates, [value]: true }
      });
  }

  const handleRefreshPosPeriods = async () => {
    const params = prepareParamsForPosUpdate(targetData?.elements);
    var promises = params.map(async bodyParams => {
    await updatePosPeriod({ bodyParams });
    });
    Promise.all(promises).then(async()=> {
      FetchTargetSales();
    });
  }

  const isOneMonthSelected = startMonth >= 0 && endMonth == null;

  return (
    <>
      <div className="formWrapper etroContainer">        
        <FormControl sx={{ m: 1, width: 170 }}>
          <OutlinedBlackBtn title="Select store(s)" variant="outlined" startIcon={<StorefrontIcon />} onClick={handleOpenModal} />
          {openModal && (<SelectStoreModal
            open={openModal}
            setOpenModal={setOpenModal}
            handleClose={handleCloseModal}
            visiblePosIds={visiblePosIds}
            setVisiblePosIds={setVisiblePosIds}
          />) }
        </FormControl>
        <FormControl sx={{ m: 1 }}>
          <MonthRangePicker
            years={JSON.parse(years)}
            selectedPeriodRange={{selectedYear: selectedYear, startMonth: startMonth, endMonth: endMonth}}
            setYear={setYear}
            setGlobalStartMonth={setGlobalStartMonth}
            setGlobalEndMonth={setGlobalEndMonth}
          />
        </FormControl>
        {featuresEnabled?.uploadExcelKPI && openKpiModal && (<UploadKpiModal
          open={openKpiModal}
          setOpenModal={handleOpenKpiModal}
          handleClose={handleCloseKpiModal}
          onSuccess={FetchTargetSales}
        />) }
        {featuresEnabled?.uploadExcelBudget && openBudgetModal && (<UploadBudgetModal
          open={openBudgetModal}
          setOpenModal={handleOpenBudgetModal}
          handleClose={handleCloseBudgetModal}
          onSuccess={FetchTargetSales}
        />) }
      </div>
      <div className="etroContainer tableOptions">
        <div className="" style={{display: 'flex', justifyContent: 'start', position: 'relative'}}>
          <div className="paginationTitle">Overall Budget ({targetData ? targetData?.totalResults : 0})</div>
          <div className="flex flex-center">
            <OutlinedBtn disabled={Object.keys(selectedPosIds).length <= 0} title="Copy budget from previous year" onClick={(event) => {setShowCopyPrevYear(!showCopyPrevYear)}} variant="outlined" startIcon={<SwapIcon />} />
            {showCopyPrevYear && (<CopyBudget targetData={targetData} selectedPosIds={selectedPosIds} selectedYear={selectedYear} handlCancelClick={setShowCopyPrevYear} afterSaveHandle={FetchTargetSales} />)}
          </div>
        </div>
        <div className="dFlex">
          {featuresEnabled?.refreshBudget && isOneMonthSelected && (<OutlinedBtn sx={{ marginRight: "22px"}} disabled={!featuresEnabled?.uploadExcelBudget} title="Refresh budget" variant="outlined" onClick={handleRefreshPosPeriods} startIcon={<RefreshIcon />} />)}
          <OutlinedBtn sx={{ marginRight: "22px"}} disabled={!featuresEnabled?.uploadExcelBudget} title="Upload Budget" variant="outlined" onClick={handleOpenBudgetModal} startIcon={<UploadIcon />} />
          <OutlinedBtn sx={{ marginRight: "22px"}} disabled={!featuresEnabled?.uploadExcelKPI} title="Upload KPI" variant="outlined" onClick={handleOpenKpiModal} startIcon={<UploadIcon />} />
          <span className="dFlex flexColumn">
            <OutlinedBtn disabled={!targetData} title="Download EXCEL" variant="outlined" onClick={downloadExcelHandleClick} startIcon={<DownloadIcon />} color={downloadError ? 'error' : ''} />
            {downloadError && (<span className="textRed">{downloadError}</span>)}
          </span>
        </div>
      </div>
      {targetData?.elements?.length > 0 ? 
      (
        <div>
          <TargetTable
            targetData={targetData}
            selectedYear={selectedYear}
            fetchTargetSales={FetchTargetSales}
            handelChangePosId={handelChangePosId}
            getBodyParams = {{
              year: selectedYear,
              months: choosedMonths(startMonth, endMonth),
              posIds: visiblePosIds,
              pageSize: pageSize,
              pageIndex: pageIndex
            }}
          />
          
          <div className="etroContainer" style={{display: 'flex', justifyContent: 'space-between', marginTop: '20px'}}>
            <Stack direction="row" spacing={2} sx={{ justifyContent: "start", alignItems: "center" }}>
              <div>Rows per page</div>
              <FormControl sx={{ m: 1, width: 80 }}>
                <Select
                  id="pageSize"
                  value={pageSize}
                  onChange={handleChangePageSzie}
                  size="small"
                >
                  {[10, 20, 50].map((pageSizeOption) => (
                    <MenuItem key={`pageSize-${pageSizeOption}`} value={pageSizeOption}>
                      <ListItemText primary={pageSizeOption} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
            <Pagination page={pageIndex} count={targetData?.totalPages} onChange={handleChangePageIndex} size="large" />
          </div>
        </div>
      ) : (
        <div className="noResultsWrapper etroContainerM">
          <NoResultsIcon />
          <div className="errorSubtext">Select a store to see</div>
          <div className="errorSubtext">the target details</div>
        </div>
      )}
    </>  
  );
};

export default Dashboard;
